import React from 'react'
import USTemplateDefault from 'src/components/template/us'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    title="Watch live TV on your flight"
    subtitle="With access to 200+ channels"
  />
)
